import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=7a8d3f3e&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=7a8d3f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d3f3e",
  null
  
)

export default component.exports